module.exports = __webpack_public_path__ + "img/active_certificate.b4b44a45.svg";